import {
  REMEMBER_REQUEST,
  REMEMBER_SUCCESS,
  FORGET_REQUEST,
  FORGET_SUCCESS,
  SET_REMEMBERED,
  SET_FORGOTTEN,
  // REMEMBER_FAILURE,
} from '../constants';
import { put, select, takeLatest } from 'redux-saga/effects';
import { callApi } from "../api";
import { RootState } from "../reducers";

export interface IRememberRequest {
  type: typeof REMEMBER_REQUEST,
  wordPairId: number;
}

export interface IForgetRequest {
  type: typeof FORGET_REQUEST,
  wordPairId: number;
}

const remember = function* (action: IRememberRequest) {
  const uri = `/remember/${action.wordPairId}`;
  const bearerToken: string = yield select((state: RootState) => state.bearerToken);

  yield callApi(
    uri,
    bearerToken,
    'POST',
  );

  yield put<{type: typeof SET_REMEMBERED}>({
    type: SET_REMEMBERED,
  });

  yield put<{type: typeof REMEMBER_SUCCESS}>({
    type: REMEMBER_SUCCESS,
  });
};

const forget = function* (action: IForgetRequest) {
  const uri = `/remember/${action.wordPairId}`;
  const bearerToken: string = yield select((state: RootState) => state.bearerToken);

  yield callApi(
    uri,
    bearerToken,
    'DELETE',
  );

  yield put<{type: typeof SET_FORGOTTEN}>({
    type: SET_FORGOTTEN,
  });

  yield put<{type: typeof FORGET_SUCCESS}>({
    type: FORGET_SUCCESS,
  });
};

const watchOnRemember = function* () {
  yield takeLatest<IRememberRequest>(REMEMBER_REQUEST, remember);
};

const watchOnForget = function* () {
  yield takeLatest<IForgetRequest>(FORGET_REQUEST, forget);
};

export {
  watchOnRemember,
  watchOnForget,
};
